'use strict'
import { axios, getErrorMessage } from '../helpers/axioshelper'

export default {
  getNormGroups() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/normgroups`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getNormGroup(normGroupId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/normgroups/${normGroupId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addNormGroup(normGroup) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/normgroups`, normGroup)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateNormGroup(normGroup) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/normgroups/${normGroup.id}`, normGroup)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteNormGroup(normGroupId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/normgroups/${normGroupId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  }
}
